import { IFetchedRegulator, IOption } from "../interfaces/team.interface";

export const transformToOptions = (array: string[]): IOption[] => {
  if (!array) return [];
  if (array.length === 0) return [];
  return array.map((item) => ({
    value: item,
    label: item,
  }));
};

export const transformRegulatorToOptions = (
  array: IFetchedRegulator[],
): IOption[] => {
  if (!array) return [];
  if (array.length === 0) return [];
  return array.map((item: IFetchedRegulator) => ({
    value: item.id.toString(),
    label: item.name,
  }));
};

export const transformRightsToOptions = (roles: {
  [key: string]: string;
}): IOption[] => {
  if (!roles) return [];
  return Object.keys(roles)
    .filter((key) => roles[key] !== "Superuser")
    .map((key) => ({
      value: key,
      label: roles[key],
    }));
};
